
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";

interface UsePasswordValidationProps {
  minLength?: number;
}

export const usePasswordValidation = ({ minLength = 6 }: UsePasswordValidationProps = {}) => {
  const [passwordError, setPasswordError] = useState("");
  const { toast } = useToast();

  const validatePassword = (password: string) => {
    if (password.length < minLength) {
      setPasswordError(`Password must be at least ${minLength} characters long`);
      return false;
    }
    
    setPasswordError("");
    return true;
  };

  const validatePasswordMatch = (password: string, confirmPassword: string) => {
    if (password !== confirmPassword) {
      setPasswordError("Passwords do not match");
      return false;
    }
    
    if (!validatePassword(password)) {
      return false;
    }
    
    setPasswordError("");
    return true;
  };

  const showPasswordError = (message: string) => {
    setPasswordError(message);
    toast({
      variant: "destructive",
      title: "Error",
      description: message,
    });
    return false;
  };

  return {
    passwordError,
    setPasswordError,
    validatePassword,
    validatePasswordMatch,
    showPasswordError
  };
};
